<template>
  <div class="sort">
    <div class="sort__title">Sortieren nach</div>
    <Select
      :listArr="sorts"
      @change="onChangeFirst"
      :currentItem="selected"
      class="sort__select"
    ></Select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Sort",
  computed: {
    ...mapGetters("products", ["getSort"]),
    selected() {
      return this.sorts.find(s => s.key === this.getSort)
        ? this.$t(this.sorts.find(s => s.key === this.getSort).locale_name)
        : "";
    }
  },
  data() {
    return {
      sorts: [
        {
          locale_name: "FL4",
          key: "desc"
        },
        {
          locale_name: "FL5",
          key: "asc"
        },
        {
          locale_name: "FL6",
          key: ""
        }
      ]
    };
  },
  methods: {
    onChangeFirst(item) {
      this.$store.dispatch("products/setSort", [item.key]);
    }
  }
};
</script>

<style scoped lang="scss">
.sort {
  &__title {
    color: #060606;
    font-family: "Lato", sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 4px;
  }
  .sort__select {
    width: 172px;
    margin: 0;
  }
}
</style>
